export default __webpack_public_path__ + "static/media/logo_MG.3897cb9c.svg";